import { FC } from "react";
import styled from "@emotion/styled";
import { MDSButton, MDSButtonVariant, MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";

interface PreviewBannerProps {
  versionNumber: number;
  onRestore: () => void;
  onExit: () => void;
}

export const PreviewBanner: FC<PreviewBannerProps> = ({ versionNumber, onRestore, onExit }) => {
  return (
    <Banner>
      <MDSText variant={MDSTextVariant.TextSm} weight={MDSTextWeight.Medium}>
        Previewing version {versionNumber} (read-only)
      </MDSText>
      <Buttons>
        <MDSButton variant={MDSButtonVariant.Transparent} onClick={onExit}>
          Exit preview
        </MDSButton>
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={onRestore}>
          Restore this version
        </MDSButton>
      </Buttons>
    </Banner>
  );
};

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["3"]};
  padding: ${({ theme }) => theme.spacing["3"]} ${({ theme }) => theme.spacing["8"]};
  background: ${({ theme }) => theme.colors.background.button.onChrome.hover};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
`;

const Buttons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing["2"]};
`;
